module.exports = __webpack_public_path__ + "media/images/rails-7d7deb52965fc6f5f5737842706c03c9.png";